<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #TiposTasaApp
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Tipos de Tasa (BCV, Binance, Paralelo, Interna, etc.)

    v-dialog(v-model='dialog', persistent max-width='500px')
      v-btn.mb-2(slot='activator', style="border-radius:5px;background-color:#ff6500;color:white;") Nuevo Tipo de Tasa
      v-card(style='background-color:white !important;')
        v-card-title.justify-center
          span.headline {{ formTitle }}
        v-card-text
          v-form(ref="form", v-model="valid")
            v-text-field(
              outline
              v-model="form.nombre"
              :rules="nombreRules"
              label="Nombre del tipo (Ej: BCV, Binance, Interna)"
              prepend-inner-icon="label"
              required
            )
            v-text-field(
              outline
              v-model="form.descripcion"
              label="Descripción (Opcional)"
              prepend-inner-icon="notes"
            )
            v-switch(
              v-model="form.activo"
              label="Activo"
              color="success"
            )
        v-card-actions(style="justify-content: center; padding-bottom: 20px;")
          v-progress-circular(v-if="loading", indeterminate, color='primary')
          template(v-else)
            v-btn(style="background:#ff6500;color:white;border-radius:10px; margin-right: 10px;", @click.native='save', :disabled="!valid") Guardar
            v-btn(style="background:black;color:white;border-radius:10px;", @click.native='close') Cancelar

    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Tipos de Tasa
        v-data-table.elevation-1(:headers='headers', :items="resultados", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.nombre }}
            td {{ props.item.descripcion || 'Sin descripción' }}
            td
              v-chip(small, :color="props.item.activo ? 'green' : 'red'", text-color="white") {{ props.item.activo ? 'Activo' : 'Inactivo' }}
            td.justify-center.layout.px-0
              v-icon.mr-2(small, @click='editItem(props.item)', color='primary') edit
              v-icon(small, @click='deleteItem(props.item)', color='error') delete
</template>

<script>
import Api from "@/services/methods";

export default {
  name: "TiposTasaApp",
  data: () => ({
    valid: true,
    loading: false,
    dialog: false,
    editedIndex: -1,
    resultados: [],
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Descripción", value: "descripcion" },
      { text: "Estado", value: "activo" },
      { text: "Acciones", value: "acciones", sortable: false }
    ],
    form: {
      nombre: "",
      descripcion: "",
      activo: true
    },
    defaultForm: {
      nombre: "",
      descripcion: "",
      activo: true
    },
    nombreRules: [
      v => !!v || "El nombre es requerido",
      v => (v && v.trim().length >= 2) || "Debe tener al menos 2 caracteres"
    ]
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Tipo de Tasa" : "Editar Tipo de Tasa";
    }
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      Api.get("tiposTasa")
        .then(res => {
          this.resultados = res.data;
        })
        .catch(error => {
          console.error("Error al obtener tipos de tasa:", error);
          this.$swal.fire("Error", "Error al cargar tipos de tasa", "error");
        });
    },
    editItem(item) {
      this.editedIndex = this.resultados.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: `Se eliminará el tipo de tasa "${item.nombre}"`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar"
        })
        .then(result => {
          if (result.value) {
            Api.delete(`tiposTasa/${item._id}`)
              .then(() => {
                this.initialize();
                this.$swal.fire("¡Eliminado!", "Tipo de tasa eliminado con éxito.", "success");
              })
              .catch(error => {
                console.error("Error eliminando tipo de tasa:", error);
                this.$swal.fire("Error", "No se pudo eliminar el tipo de tasa", "error");
              });
          }
        });
    },
    close() {
      this.dialog = false;
      this.form = Object.assign({}, this.defaultForm);
      this.editedIndex = -1;
      this.$refs.form && this.$refs.form.resetValidation();
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const payload = {
          nombre: this.form.nombre.trim(),
          descripcion: this.form.descripcion ? this.form.descripcion.trim() : "",
          activo: this.form.activo !== undefined ? this.form.activo : true
        };

        if (this.editedIndex > -1) {
          Api.put(`tiposTasa/${this.resultados[this.editedIndex]._id}`, payload)
            .then(() => {
              this.initialize();
              this.close();
              this.$swal.fire("¡Actualizado!", "Tipo de tasa actualizado correctamente.", "success");
            })
            .catch(error => {
              console.error("Error actualizando tipo de tasa:", error);
              const msg = (error.response && error.response.data && error.response.data.message) || "Error al actualizar";
              this.$swal.fire("Error", msg, "error");
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          Api.post("tiposTasa", payload)
            .then(() => {
              this.initialize();
              this.close();
              this.$swal.fire("¡Creado!", "Tipo de tasa creado con éxito.", "success");
            })
            .catch(error => {
              console.error("Error creando tipo de tasa:", error);
              const msg = (error.response && error.response.data && error.response.data.message) || "Error al crear";
              this.$swal.fire("Error", msg, "error");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>

<style scoped>
.v-data-table {
  background-color: white;
}
.theme--light.v-data-table {
  background-color: white;
  color: rgba(0, 0, 0, 0.87);
}
.v-data-table .v-data-table-header th {
  background-color: #f5f5f5;
  font-weight: bold;
}
</style>
